import {reactive} from "vue";

class FormaPagamentoTarifaEvents {

    listenerFormaPagamentoTarifaGravada = reactive({value: {formaPagamentoTarifaId: ''}})
    listenerFormaPagamentoTarifaAlterada = reactive({value: {formaPagamentoTarifaId: ''}})
    listenerFormaPagamentoTarifaRemovida = reactive({value: {formaPagamentoTarifaId: ''}})
    listenerFormaPagamentoTarifaExportada = reactive({value: {formaPagamentoTarifaId: ''}})

    emitFormaPagamentoTarifaGravada(formaPagamentoTarifaId: string) {
        this.listenerFormaPagamentoTarifaGravada.value = {formaPagamentoTarifaId: formaPagamentoTarifaId}
    }

    emitFormaPagamentoTarifaAlterada(formaPagamentoTarifaId: string) {
        this.listenerFormaPagamentoTarifaAlterada.value = {formaPagamentoTarifaId: formaPagamentoTarifaId}
    }

    emitFormaPagamentoTarifaRemovida(formaPagamentoTarifaId: string) {
        this.listenerFormaPagamentoTarifaRemovida.value = {formaPagamentoTarifaId: formaPagamentoTarifaId}
    }
    emitFormaPagamentoTarifaExportada(formaPagamentoTarifaId: string) {
        this.listenerFormaPagamentoTarifaExportada.value = {formaPagamentoTarifaId: formaPagamentoTarifaId}
    }


}

export default FormaPagamentoTarifaEvents;